// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__FK1a1","name":"name__IHrgP","badge":"badge__RnP3N"};